import { resolvePublicFileUrl } from "../constants/api-urls";
import { ILE_TRANSACTION_TYPES } from "./infrastructureLeasingSearchConfig";
import { getSearchCardAvailabilityBadge } from "./infrastructureListingInventoryAvailabilityUi";

const SPEC_SLOT_COUNT = 4;

export function formatInfraMetric(value) {
  if (value == null || value === "" || value === "—") return "—";
  return String(value);
}

export function getInfraListingImagePath(item) {
  return item?.imagePath || item?.image_path || null;
}

export function getInfraListingDetailHref(item, detailTab = "real-estate") {
  return `/infrastructure-leasing/listing/${item.id}?tab=${detailTab}`;
}

export function getInfraTransactionLabel(transactionType) {
  return (ILE_TRANSACTION_TYPES.find((entry) => entry.value === (transactionType || "lease")) || {
    label: "Lease",
  }).label;
}

export function isNewInfraListing(updatedAt) {
  if (!updatedAt) return false;
  return Date.now() - new Date(updatedAt).getTime() < 7 * 24 * 60 * 60 * 1000;
}

export function buildInfraListingSpecItems(item) {
  const specs = [];
  const transactionLabel = getInfraTransactionLabel(item.transactionType);
  if (transactionLabel) specs.push({ label: "Type", value: transactionLabel });
  if (item.categoryLabel && item.categoryLabel !== "—") {
    specs.push({ label: "Category", value: item.categoryLabel });
  }
  if (item.keySpec && item.keySpec !== "—") {
    specs.push({ label: "Spec", value: item.keySpec });
  }
  const availability = getSearchCardAvailabilityBadge(item);
  if (availability?.label) {
    specs.push({ label: "Availability", value: availability.label });
  } else if (item.ownershipType) {
    specs.push({
      label: "Ownership",
      value: String(item.ownershipType).replace(/_/g, " "),
    });
  }

  const slots = specs.slice(0, SPEC_SLOT_COUNT).map((spec) => ({ ...spec, empty: false }));
  while (slots.length < SPEC_SLOT_COUNT) {
    slots.push({ label: "", value: "", empty: true });
  }
  return slots;
}

export function resolveInfraListingRibbon(item) {
  const availability = getSearchCardAvailabilityBadge(item);
  if (availability?.label) {
    const isPositive =
      availability.className?.includes("available") ||
      availability.className?.includes("partial");
    return {
      label: availability.label.toUpperCase(),
      className: isPositive
        ? "marketplace-product-grid-card__ribbon--certified"
        : "marketplace-product-grid-card__ribbon--seller",
    };
  }
  if (isNewInfraListing(item.updatedAt)) {
    return { label: "NEW", className: "marketplace-product-grid-card__ribbon--seller" };
  }
  return null;
}

export function resolveInfraListingRowBadge(item) {
  const ribbon = resolveInfraListingRibbon(item);
  if (!ribbon) return null;
  return {
    label: ribbon.label,
    className: ribbon.className.includes("certified")
      ? "marketplace-product-row__badge--certified"
      : "marketplace-product-row__badge--seller",
  };
}

export function getInfraListingLocation(item) {
  const location = item?.locationLine;
  return location && location !== "—" ? location : "";
}

export function getInfraListingPriceLabel(item) {
  return item?.pricePrimary || item?.price || "";
}

export function getInfraListingCategoryTrail(item) {
  return [item?.categoryLabel, item?.propertyType, item?.subCategory]
    .map((part) => formatInfraMetric(part))
    .filter((part) => part && part !== "—");
}

export function getInfraListingShareImage(item) {
  const imagePath = getInfraListingImagePath(item);
  return imagePath ? resolvePublicFileUrl(imagePath) : "";
}
